export default "__VITE_ASSET__CIWFAaHA__"